import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { SmallMap, BackArrow } from '@lt/components/icons-react/floating-panel';

import { pushMapExpanded } from 'src/routes/SearchPage/components/YandexMapsSearch/analytics';
import { PAGINATION } from 'src/routes/SearchPage/store/hotels/constants';

import {
  FloatingPanelButton,
  ButtonContainer,
  BottomButtonText,
} from '../styles';
import {
  BACK_ICON_DATA_TEST_ID,
  MAP_ICON_DATA_TEST_ID,
  TOGGLE_MAP_BUTTON_DATA_TEST_ID,
} from './constants';

interface IToggleMapButton {
  toggleHandler: () => void;
  setVisibleHotelsLimit?: (newVisibleLimit) => void;
  mapView: boolean;
}

const ToggleMapButton = ({
  toggleHandler,
  setVisibleHotelsLimit,
  mapView,
}: IToggleMapButton) => {
  const { t } = useTranslation();

  const Icon = mapView ? (
    <StyledBackIcon data-testid={BACK_ICON_DATA_TEST_ID} />
  ) : (
    <StyledMapIcon data-testid={MAP_ICON_DATA_TEST_ID} />
  );

  const text = mapView ? t('search.map.back') : t('hotel.topMenu.map');

  const handleClick = () => {
    // Обнуляем visibleLimit, чтобы не зависала страница при закрытии карты
    if (mapView) {
      setVisibleHotelsLimit?.(PAGINATION.VISIBLE_LIMIT);
    }

    toggleHandler();

    pushMapExpanded(mapView);
  };

  return (
    <Button
      type="button"
      onClick={handleClick}
      data-testid={TOGGLE_MAP_BUTTON_DATA_TEST_ID}
    >
      <ButtonContainer>
        {Icon}
        <BottomButtonText>{text}</BottomButtonText>
      </ButtonContainer>
    </Button>
  );
};

const StyledMapIcon = styled(SmallMap)`
  width: 24px;
  height: 24px;
`;

const StyledBackIcon = styled(BackArrow)`
  width: 24px;
  height: 24px;
`;

const Button = styled(FloatingPanelButton)`
  border-top-right-radius: 28px;
  border-bottom-right-radius: 28px;
`;

export default ToggleMapButton;
